var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35.965mm",
    height: "35.962mm",
    viewBox: "0 0 35.965 35.962",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-77.628 -82.378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m113.59 85.344v7.3448c-0.0873 1.524-1.3467 2.7331-2.8919 2.7331-0.0159 0-0.0291-0.0026-0.045-0.0026v0.0053h-14.055c-0.58208 0-1.0927 0.44979-1.1086 1.0319-0.01588 0.59796 0.46567 1.0874 1.0583 1.0874h14.526c1.3705 0.17727 2.4368 1.307 2.5162 2.7067v15.121c0 1.6404-1.3308 2.9686-2.9686 2.9686h-30.028c-1.6404 0-2.9686-1.3308-2.9686-2.9686v-7.1226c0.07937-1.3838 1.1271-2.5056 2.4791-2.6988h14.523c0.59531 0 1.0742-0.48947 1.0583-1.0874-0.01587-0.58209-0.52652-1.0319-1.1086-1.0319h-14.253c-1.5002-0.11377-2.6802-1.3626-2.6802-2.8892 0-0.0344 0.0026-0.0661 0.0053-0.0979h-0.02381v-15.097c0-1.6404 1.3309-2.9686 2.9686-2.9686h30.028c1.6404-0.0053 2.9686 1.3256 2.9686 2.966z",
    fill: "#0083c1",
    strokeWidth: 0.26458
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.bbeedbcf9f0e5155e61fc436ecd18dcc.svg";
export { ForwardRef as ReactComponent };